import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.EditCounterpartyPaymentDetailsPopupContent.SecondStep', {
    paymentMethod: 'Payment method',
    enityType: 'Entity type',
    company: 'Company',
    individual: 'Individual',
    selectPlaceholder: 'Select...',
});
